export function wrapScriptForExecution(type: string, content: string): string {
  if (type === 'cmd') return content;

  const escaped = content.replace(/'/g, "''");

  if (type === 'bat') {
    return `$f="$env:TEMP\\rmm_script.bat"; Set-Content $f '${escaped}' -Encoding ASCII; cmd /c $f; Remove-Item $f`;
  }

  if (type === 'ps1') {
    return `$f="$env:TEMP\\rmm_script.ps1"; Set-Content $f '${escaped}' -Encoding UTF8; powershell -ExecutionPolicy Bypass -File $f; Remove-Item $f`;
  }

  return content;
}
